export default __webpack_public_path__ + "static/media/affligem_s1.e622f73a.png";